
import React from 'react';

export const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: 'ri-building-2-line',
      title: '구조물 계측',
      description: '교량, 터널, 건물 등 구조물의 변형, 진동, 응력을 실시간으로 모니터링하여 구조적 안전성을 확보합니다.',
      image: 'https://public.readdy.ai/ai/img_res/6944a90aab0a1be45874807ded3c6328.jpg'
    },
    {
      icon: 'ri-earth-line',
      title: '지반 모니터링',
      description: '지반 침하, 지하수위, 토압 등을 정밀 계측하여 지반 안정성을 평가하고 사고를 예방합니다.',
      image: 'https://readdy.ai/api/search-image?query=Ground%20monitoring%20equipment%20in%20construction%20site%2C%20soil%20sensors%2C%20groundwater%20level%20measurement%20devices%2C%20geotechnical%20monitoring%20systems%2C%20professional%20installation%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20industrial%20setup%2C%20advanced%20monitoring%20technology&width=600&height=400&seq=ground-monitoring&orientation=landscape'
    },
    {
      icon: 'ri-leaf-line',
      title: '환경 계측',
      description: '소음, 진동, 대기질, 수질 등 환경 요소를 모니터링하여 친환경 건설을 실현합니다.',
      image: 'https://readdy.ai/api/search-image?query=Environmental%20monitoring%20station%20at%20construction%20site%2C%20air%20quality%20sensors%2C%20noise%20measurement%20equipment%2C%20water%20quality%20testing%20devices%2C%20green%20technology%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20professional%20setup%2C%20eco-friendly%20monitoring%20systems&width=600&height=400&seq=environmental-monitoring&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: '안전 관리',
      description: '작업자 안전, 장비 상태, 위험 구역 모니터링을 통해 사고 없는 안전한 건설 현장을 만듭니다.',
      image: 'https://readdy.ai/api/search-image?query=Construction%20safety%20monitoring%20system%2C%20worker%20safety%20sensors%2C%20equipment%20status%20monitoring%2C%20danger%20zone%20detection%2C%20safety%20management%20dashboard%2C%20blue%20and%20white%20color%20scheme%2C%20professional%20safety%20equipment%2C%20high-tech%20monitoring%20setup&width=600&height=400&seq=safety-monitoring&orientation=landscape'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: '데이터 분석',
      description: 'AI와 빅데이터 기술을 활용하여 계측 데이터를 분석하고 예측 모델을 제공합니다.',
      image: 'https://readdy.ai/api/search-image?query=Data%20analysis%20dashboard%20for%20construction%20monitoring%2C%20AI%20analytics%20interface%2C%20big%20data%20visualization%2C%20predictive%20modeling%20charts%2C%20professional%20software%20interface%2C%20blue%20and%20white%20color%20scheme%2C%20modern%20digital%20displays%2C%20high-tech%20data%20center&width=600&height=400&seq=data-analysis&orientation=landscape'
    },
    {
      icon: 'ri-smartphone-line',
      title: '모바일 앱',
      description: '언제 어디서나 모바일 앱을 통해 실시간 데이터 확인 및 알림을 받을 수 있습니다.',
      image: 'https://readdy.ai/api/search-image?query=Mobile%20app%20interface%20for%20construction%20monitoring%2C%20smartphone%20displaying%20real-time%20data%2C%20professional%20mobile%20application%2C%20construction%20site%20background%2C%20blue%20and%20white%20color%20scheme%2C%20modern%20UI%20design%2C%20high-tech%20mobile%20technology&width=600&height=400&seq=mobile-app&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            핵심 기능
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            건설 현장의 모든 요소를 통합적으로 관리하는 스마트 계측 솔루션
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url(${feature.image})` }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
